import { z } from 'zod';

import { CogniteAssetModel } from '#core/schema/model/cdm/CogniteAssetModel';

import { ReservoirModel } from '#schema/model/ReservoirModel';

export const FieldModel = z
  .object({
    ...CogniteAssetModel.shape,

    children: ReservoirModel.array().optional().default([]),

    fullName: z.string().optional().describe('Full name of the field.'),
  })
  .describe('Field asset, representing a collection of reservoirs');

export type FieldModelInput = z.input<typeof FieldModel>;
export type FieldModelOutput = z.output<typeof FieldModel>;
